import React, { useEffect, useState } from "react";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import { IP } from "../../../../internalServer";
import ZoomableImage from "./ZoomableImage";

export default function CheckBoxType({
  question,
  questionNo,
  setQuestionsAnswer,
  questionsAnswer,
}) {
  const [responseAttach, setResponseAttach] = useState();
  const [checkboxes, setCheckboxes] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  useEffect(() => {
    !questionsAnswer.find((i) => i.question_id === question?.id) &&
      setQuestionsAnswer((prev) => [
        ...prev,
        {
          question_id: question?.id,
          answer: {
            key: null,
            explanation: null,
          },
        },
      ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   console.log("question from on pending : ", question)
  //   console.log("questionNo from on pending : ", questionNo)
  //   console.log("questionsAnswer from on review : ", questionsAnswer)
  // }, [])

  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  const handleCheckboxChange = (option) => {
    // checkboxes === option?.key
    //   ? setCheckboxes(null)
    //   : setCheckboxes(option?.key);
    // checkboxes === option?.key
    //   ? setQuestionsAnswer((prev) =>
    //       prev.filter((i) => i.question_id !== question?.id)
    //     )
    //   : setQuestionsAnswer((prev) => {
    //       const prevData = prev.filter((i) => i.question_id !== question?.id);
    //       return [
    //         ...prevData,
    //         {
    //           question_id: question?.id,
    //           answer: {
    //             key: option?.key,
    //             explanation: option?.value,
    //           },
    //         },
    //       ];
    //     });
    setQuestionsAnswer((prev) => {
      let updatedData = prev.map((item) => {
        if (item.question_id === question?.id) {
          if (item.answer.key === option?.key) {
            return {
              ...item,
              answer: {
                key: "",
                explanation: "",
              },
            };
          } else {
            return {
              ...item,
              answer: {
                key: option?.key,
                explanation: option?.value,
              },
            };
          }
        }
        return item;
      });

      if (!updatedData.some((item) => item.question_id === question?.id)) {
        updatedData.push({
          question_id: question?.id,
          answer: {
            key: option?.key,
            explanation: option?.value,
          },
        });
      }

      return updatedData;
    });
  };

  return (
    <>
      <div className="containerBelowQuestion" style={{ height: "280px" }}>
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. {question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue">{question?.correct_score} Marks</div> */}
        </div>
        {question?.attachments?.length > 0 &&
          question?.attachments?.map((attachment, index) => (
            <div key={index}>
              {attachment.split(".").pop() !== "mp4" ? (
                <>
                  {attachment.split(".").pop() === "jpg" ||
                    attachment.split(".").pop() === "JPG" ||
                    attachment.split(".").pop() === "PNG" ||
                    attachment.split(".").pop() === "jpeg" ||
                    attachment.split(".").pop() === "JPEG" ||
                    attachment.split(".").pop() === "png" ? (
                    <img
                      style={{ cursor: "pointer" }}
                      className="mt-3 imageWidthAndHeight"
                      src={IP + attachment?.replace(/^\./, "")}
                      alt="Attachment"
                      onClick={() => {
                        if (!isError) {
                          handleClick(attachment);
                        }
                      }}
                    />
                  ) : (
                    <div
                      key={index}
                      onClick={(e) => {
                        setPedingSubDetail({
                          ...pedingSubDetail,
                          pdfView: true,
                          attachment: attachment,
                        });
                      }}
                      className="mt-2"
                    >

                      <div className="d-flex pdfContainer gap-2 p-2 ">
                        <div className="d-flex align-items-center">
                          <img
                            className="extention_icon"
                            src={`${iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1]
                            )?.icon
                              }`}
                            alt=""
                          />
                        </div>
                        <div className="w-100">
                          <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                            {attachment?.replace(/^[^_]*_/, "")}
                          </div>
                          <div className="pdfFileSize">12 KB</div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex pdfContainer gap-2 p-2 "
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}>
                  <div className="d-flex align-items-center">
                    <img
                      className="extention_icon"
                      src={`${iconData?.find(
                        (i) =>
                          i.extension ===
                          attachment?.match(/\.([^.]+)$/)[1]
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                  <div className="w-100">
                    <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                      {attachment?.replace(/^[^_]*_/, "")}
                    </div>
                    <div className="pdfFileSize">12 KB</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        <div className="mt-4 optionContainer ml-2">
          {question?.options?.length > 0 &&
            question?.options?.map((option, index) => {
              return (
                <>
                  <div key={option?.key} className="d-flex justify-content-between">
                    <div className="d-flex gap-2 ">
                      <div style={{ width: "50px" }}>
                        {
                          option?.key + ". "
                        }
                        <input
                          type="checkbox"
                          className="hwCheckbox ml-1"
                          checked={
                            // checkboxes === option?.key ||
                            questionsAnswer.find(
                              (i) => i?.question_id === question?.id
                            )?.answer?.key === option?.key
                          }
                          onChange={() => handleCheckboxChange(option)}
                        />
                      </div>
                      <div
                        className={` ${questionsAnswer.find(
                          (i) => i?.question_id === question?.id
                        )?.answer?.key === option?.key
                          ? "QueOptionsChecked"
                          : "QueOptions"
                          }`}
                      >
                        {option?.value}
                      </div>
                    </div>
                    {questionsAnswer.find((i) => i?.question_id === question?.id)
                      ?.answer?.key === option?.key && (
                        <div className="yourAnswer">Your answer</div>
                      )}
                  </div>
                  <div className="ml-6">
                    {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()}
                  </div>
                </>
              )
            })}
        </div>
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>

                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
